<template>
  <div class="container orders-page">
    <v-head></v-head>
    <v-left current="refund"></v-left>
    <div>
      <div class="filter-dic">
        <el-input
          size="mini"
          v-model="filter.keyword"
          placeholder="搜单号、手机号"
          clearable
          @clear="search"
          @change="search"
          class="w240 input-with-select"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="search"
          ></el-button>
        </el-input>
        <el-select
          v-model="filter.platform"
          placeholder="应用类型"
          clearable
          @clear="search"
          @change="search"
          size="mini"
          class="w130"
        >
          <el-option
            v-for="item in $store.state.public.cfg.platform_options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="filter.app_id"
          placeholder="应用"
          size="mini"
          class="w200"
          @change="search"
          @clear="search"
          clearable
        >
          <el-option
            v-for="item in $store.state.public.cfg.apps_options"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="filter.refund_status"
          placeholder="退单状态"
          clearable
          @clear="search"
          @change="search"
          size="mini"
          class="w130"
        >
          <el-option
            v-for="item in $store.state.public.cfg.refund_status_options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
          size="mini"
          class="w240"
          v-model="filter.time_range"
          clearable
          @change="search"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </div>
      <div class="list-dom">
        <el-table
          :data="list_data.list"
          v-loading="loading"
          style="width: 100%"
        >
          <el-table-column
            prop="refund_no"
            label="退单号"
            width="111"
          ></el-table-column>
          <el-table-column prop="order_no" label="订单号" width="111">
            <template slot-scope="scope">
              <span
                class="pointer"
                @click="
                  redirect(
                    '/orders/detail?order_id=' + scope.row.order_id,
                    true
                  )
                "
                >{{ scope.row.order_no }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="typeShow.label"
            label="订单类型"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="card_id"
            label="手机号"
            width="133"
          ></el-table-column>
          <el-table-column prop="refund_status" label="退款状态" width="88">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.refundStatusShow.u_tag">{{
                scope.row.refundStatusShow.label
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="amount_total_payed"
            label="实付金额"
            width="88"
          ></el-table-column>
          <el-table-column
            prop="refund_amount"
            label="退款金额"
            width="88"
          ></el-table-column>
          <el-table-column
            prop="refund_ctime"
            label="退款时间"
            width="166"
          ></el-table-column>
          <el-table-column
            prop="refund_time_success"
            label="退款受理时间"
            width="166"
          ></el-table-column>
          <el-table-column
            prop="refund_reason"
            label="退单原因"
            width="144"
          ></el-table-column>
          <el-table-column
            prop="pay_time"
            label="支付时间"
            width="166"
          ></el-table-column>
          <el-table-column
            prop="app_name_full"
            label="应用类型"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="ctime"
            label="下单时间"
            width="166"
          ></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <a>查看</a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="my-page"
          background
          :page-size="list_data.size"
          layout="prev, pager, next"
          @current-change="changePage"
          :total="list_data.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";
export default {
  components: {
    "v-head": head,
    "v-left": left,
  },
  data() {
    return {
      loading: false,
      filter: {
        page: 1,
        platform: "",
        app_id: "",
        keyword: "",
        refund_status: "",
        time_range: [],
      },
      list_data: {
        size: 20,
        page: 1,
        total: 0,
        list: [],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    changePage(e) {
      this.filter.page = e;
      this.getList();
    },
    search() {
      this.filter.page = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.$http.post("/v1/pri/refund/lists", this.filter).then((response) => {
        this.loading = false;
        var res = response.data;
        if (res.code == 1) {
          this.list_data = res.data;
          this.filter.size = res.data.size;
        }
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped>
.orders-page .filter-dic {
  margin-bottom: 14px;
}
</style>


// WEBPACK FOOTER //
// src/pages/refund/Index.vue